module.exports = __webpack_public_path__ + "img/icon103.dccebd7a.png";